module.exports = __webpack_public_path__ + "static/media/GlacialIndifference-Bold.91ff51d6.woff2";